import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import CalendarPicker from '@mui/lab/CalendarPicker';

const styles = theme => ({
	iconButton: {
		backgroundColor: '#465A65'
	}
});

const Calendar = ({
	selectedDate,
	handleDateChange,
	classes,
	...rest
}) => {
	const [selectedStateDate, setSelectedDate] = useState({
		date: selectedDate,
		onChange: handleDateChange
	});

	const handleChange = date => {
		setSelectedDate(date);
		handleDateChange(date);
	};

	return (
		<div>
			<Paper
				square
				style={{ overflow: 'hidden' }}
			>
				<CalendarPicker date={selectedStateDate} onChange={handleChange} />
			</Paper>
		</div>
	);
};

Calendar.propTypes = {
	selectedDate: PropTypes.any.isRequired,
	handleDateChange: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Calendar);
